import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: to => ({
      path: '/steps/prerequisite',
      query: to.query
    })
  },
  {
    path: '/steps/prerequisite',
    name: 'Prerequisite',
    component: () => import('@/views/steps/Prerequisite.vue'),
    meta: { title: '入驻前提', step: 0 }
  },
  {
    path: '/steps/license',
    name: 'License',
    component: () => import('@/views/steps/License.vue'),
    meta: { title: '营业执照', step: 1 }
  },
  {
    path: '/steps/legal',
    name: 'Legal',
    component: () => import('@/views/steps/Legal.vue'),
    meta: { title: '法人信息', step: 2 }
  },
  {
    path: '/steps/basic',
    name: 'Basic',
    component: () => import('@/views/steps/Basic.vue'),
    meta: { title: '经营信息', step: 3 }
  },
  {
    path: '/steps/contact',
    name: 'Contact',
    component: () => import('@/views/steps/Contact.vue'),
    meta: { title: '管理员信息', step: 4 }
  },
  {
    path: '/steps/bank',
    name: 'Bank',
    component: () => import('@/views/steps/Bank.vue'),
    meta: { title: '银行卡信息', step: 5 }
  },
  {
    path: '/search/bank',
    name: 'BankSearch',
    component: () => import('@/views/search/BankSearch.vue'),
    meta: { title: '选择银行' }
  },
  {
    path: '/search/branch',
    name: 'BranchSearch',
    component: () => import('@/views/search/BranchSearch.vue'),
    meta: { title: '搜索联行号' }
  },
  {
    path: '/result',
    name: 'Result',
    component: () => import('@/views/Result.vue'),
    meta: { title: '提交结果' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 商户入驻` : '商户入驻'
  next()
})

export default router
